import React from 'react';
import CommonTable from 'components/CommonTable';
import styled from 'styled-components';
import { Spinner } from 'react-bootstrap';
import { CustomButton } from 'components/CustomForm';
import useModal from 'hooks/useModal';
import BuyHistoryModal from './BuyHistoryModal';

const cols = [
	'مشاهده سوابق',
	'واحد',
	'موجودی',
	'نوع نهاده',
	'ردیف'
];

const Holder = styled.div`
  width: 100%;

  div.loading {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #3876e5;
    min-height: 30rem;
  }

  div.empty {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 10rem;
	text-align: center;
	color: #616161;
	font-size: 14pt;
  }
`;

const StoreTab = ({ storeData, isLoading, parentType }) => {
	const { isOpen, handleOpenModal, handleCloseModal, data: modalData } = useModal();

	const getList = () => {
		const inputs = storeData?.data?.inputs ?? [];
		const concentrate = storeData?.data?.concentrate;
		if (concentrate) {
			return [concentrate, ...inputs];
		} else {
			return inputs;
		}
	};
	const isListEmpty = () => getList().length < 1;

	return (
		<Holder>
			{isLoading ? (
				<div className="loading">
					<Spinner animation="border" role="status" />
				</div>
			) : (
				isListEmpty() ? (
					<div className='empty'>در حال حاضر رکوردی وجود ندارد</div>
				) : (
					<CommonTable cols={cols}>
						{getList().map((item, index) => (
							<tr key={`${item?.input_id}-${index}`}>
								<td className="d-flex align-items-center justify-content-center">
									<CustomButton
										onClick={() => handleOpenModal(item)}
									>
										نمایش
									</CustomButton>
								</td>
								<td>{storeData?.data?.unit?.name ?? '-'}</td>
								<td>{`${item?.sum ?? 0}`.persianCurrency()}</td>
								<td>{item?.name?.name || item?.name}</td>
								<td>{index + 1}</td>
							</tr>
						))}
					</CommonTable>
				)
			)}
			{isOpen && (
				<BuyHistoryModal
					isOpen={isOpen}
					onClose={handleCloseModal}
					data={modalData}
					parentType={parentType}
				/>
			)}
		</Holder>
	);
};

export default StoreTab;
